// src/pages/DashboardPage.jsx
import MainLayout from "../layouts/MainLayout";
import EditStudentRecord from "./EditStudentRecord";

const Editstudentrecordpage = () => {

  return (
    <MainLayout title="Edit Student Record">
        {/* Main Content */}
        <div style={{ flex: 1 }}>
          <EditStudentRecord/>
        </div>
    </MainLayout>
  );
};

export default Editstudentrecordpage;
